import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { nok } from "@/lib/format";

export function useChartColors() {
  const { resolvedTheme } = useTheme();
  const [c, setC] = useState({});
  useEffect(() => {
    const s = getComputedStyle(document.documentElement);
    const v = (n) => `hsl(${s.getPropertyValue(n).trim()})`;
    setC({
      inntekter: v("--chart-2"),
      resultat: v("--chart-1"),
      kostnader: v("--muted-foreground"),
      lime: v("--lime"),
      grid: v("--border"),
      axis: v("--muted-foreground"),
    });
  }, [resolvedTheme]);
  return c;
}

export const kFmt = (v) => `${Math.round(v / 1000)}k`;

export function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-border bg-popover px-3 py-2 text-xs shadow-lg" data-testid="chart-tooltip">
      <p className="mb-1 font-semibold">{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="flex items-center justify-between gap-4">
          <span className="flex items-center gap-1.5">
            <span className="inline-block h-2 w-2 rounded-full" style={{ background: p.color }} />
            {p.name}
          </span>
          <span className="font-medium tabular-nums">{nok(p.value)}</span>
        </p>
      ))}
    </div>
  );
}
